<template>
  <div v-if="show" class="login-view">
    <div class="login-container">
      <div class="login-header">
        <div class="logo"></div>
        <p>锐深科技云平台管理端</p>
      </div>
      <div class="login-main">
        <p class="title item">管理员登录</p>
        <el-input
          v-model="username"
          class="item"
          placeholder="请输入账号"
        ></el-input>
        <el-input
          v-model="password"
          class="item"
          type="password"
          placeholder="请输入密码"
          @keydown.enter="handleSubmit"
        ></el-input>
        <div class="operations">
          <el-link type="info" @click="forgetPassword">忘记密码</el-link>
        </div>
        <el-button
          type="primary"
          class="item button"
          color="#f332e3"
          @click="handleSubmit"
        >
          LOGIN
        </el-button>
        <p class="footer">
          COPYRIGHT © 2019-2026 深圳市锐深科技有限公司 版权所有
          <a
            class="beian-link"
            href="https://beian.miit.gov.cn"
            target="_blank"
            rel="noopener noreferrer"
            >粤ICP备17088454号-3</a
          >
        </p>
        <div class="item"></div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { http } from "@/main";
import { useRouter } from "vue-router";
import store from "@/store";
import { ElMessage } from "element-plus";
import { loadTranslations } from "@/composables/useTranslation";
import { loadProtocolText } from "@/composables/useProtocolText";

const username = ref<string>("");
const password = ref<string>("");
const router = useRouter();

const show = ref<boolean>(false);
const verifyToken = async () => {
  const result = await store.dispatch("auth/verifyToken");
  console.log(result);
  if (result) {
    router.push({ name: "overall" });
  }
  show.value = true;
};

const handleSubmit = async () => {
  try {
    const response = await http.post("/login", {
      username: username.value,
      password: password.value,
    });
    console.log(response.data);
    const token = response.data.token;
    store.commit("auth/setToken", token);
    store.dispatch("auth/verifyToken");
    // 登录态建立后加载翻译表/协议枚举缓存：
    // App 挂载发生在登录页阶段，彼时未登录，loadTranslations/loadProtocolText 已 401 失败，
    // 不在此补加载则登录后首次进入的页面设备名/枚举翻译为空（刷新后才能恢复）
    loadTranslations();
    loadProtocolText();
    router.push({ name: "overall" });
  } catch (err) {
    console.error(err);
    ElMessage.error("登陆失败，请检查你的用户名和密码");
  }
};
const forgetPassword = () => {
  router.push({ name: "resetPassword" });
};

onMounted(() => {
  verifyToken();
});
</script>
<style lang="less" scoped>
.login-view {
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &::after {
    position: absolute;
    opacity: 0.7;
    width: 100%;
    height: 100%;
    content: "";
    background-image: url("../assets/loginbg.jpg");
    background-size: cover;
    z-index: -1;
  }
}
.login-container {
  width: 600px;
  height: 500px;
  background-color: #ffffff;
  margin-top: -50px;
  box-shadow: 0 0 15px 1px rgba(247, 102, 181, 0.548);
}
.login-header {
  height: 20%;
  background-color: #f332e3;
  display: flex;
  align-items: center;
  padding-left: 30px;
  font-size: 22px;
  color: white;
  font-weight: bolder;
  font-family: "SimHei";
}
.title {
  font-weight: bolder;
  font-size: 24px;
  height: 24px !important;
}
.logo {
  width: 120px;
  height: 30%;
  background-image: url("../assets/logo.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.login-main {
  height: 80%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.item {
  width: 50%;
  height: 50px;
  margin: 10px;
}
.operations {
  width: 50%;
  text-align: right;
}
.button {
  font-weight: bolder;
  font-size: 18px;
  letter-spacing: 1px;
  color: #ffffff;
}
.footer {
  font-size: 12px;
  color: grey;
  position: absolute;
  bottom: 20px;
}
/* 备案号链接：工信部要求可点击跳转 https://beian.miit.gov.cn */
.footer .beian-link {
  color: grey;
  margin-left: 8px;
  text-decoration: none;
  &:hover {
    color: #409eff;
    text-decoration: underline;
  }
}
</style>
